<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import Button from 'primevue/button';
import InlineMessage from 'primevue/inlinemessage';
import OpcoesTopico from '@/components/professor/CriarQuestoes/OpcoesTopico.vue';
import OpcoesSubtopicosSugeridos from '@/components/professor/CriarQuestoes/OpcoesSubtopicosSugeridos.vue';
import OpcoesFonteDados from '@/components/professor/CriarQuestoes/OpcoesFonteDados.vue';

import { useCriarQuestoesStore } from "@/store/criarQuestoes";
import OpcoesTipoPergunta from '@/components/professor/CriarQuestoes/OpcoesTipoPergunta.vue';
import OpcoesModeloQuestao from '@/components/professor/CriarQuestoes/OpcoesModeloQuestao.vue';
import OpcoesDisciplinas from '@/components/professor/CriarQuestoes/OpcoesDisciplinas.vue';
import OpcoesTextoDigitado from '@/components/professor/CriarQuestoes/OpcoesTextoDigitado.vue';
import OpcoesQuantidadeQuestoes from '@/components/professor/CriarQuestoes/OpcoesQuantidadeQuestoes.vue';
import EditarQuestao from '@/components/professor/CriarQuestoes/EditarQuestao.vue';

import { useModeloQuestao } from '@/composables/useModeloQuestao';

const store = useCriarQuestoesStore();
const { fonteDadosParaQuestao, btnCriarQuestaoLoading, mensagemErroInline, modelosQuestoes, tipoPerguntaSelecionada, disciplinaSelecionada } = storeToRefs(store);

const modeloQuestao = useModeloQuestao();
const questao = ref({...modeloQuestao})

</script>

<template>
    <div class="flex flex-column gap-5 mt-7 pb-7">
        <OpcoesFonteDados class="pb-2 pt-2"/>
        <div class="flex flex-column gap-5" v-if="fonteDadosParaQuestao !== 2">
            <div class="grid">
                <OpcoesTipoPergunta v-model="tipoPerguntaSelecionada" class="col-12 lg:col-6" />
                <OpcoesDisciplinas v-model="disciplinaSelecionada" class="col-12 lg:col-6" />
            </div>
            <OpcoesQuantidadeQuestoes />

            <OpcoesModeloQuestao v-if="modelosQuestoes.length > 0" />

            <div v-if="fonteDadosParaQuestao === 0" class="flex flex-column  gap-4">
                <OpcoesTopico />
                <OpcoesSubtopicosSugeridos />
            </div>

            <div v-if="fonteDadosParaQuestao === 1">
                <OpcoesTextoDigitado />
            </div>
            <div class="flex flex-column gap-3">
                <InlineMessage v-if="mensagemErroInline" severity="error">Preencha os campos necessários</InlineMessage>

                <Button :loading="btnCriarQuestaoLoading" label="Criar Questões" icon="pi pi-sparkles"
                    @click="store.validarCriarQuestoes" />
            </div>
        </div>

        <!-- Componentes no modo manual -->
        <div v-if="fonteDadosParaQuestao === 2">
            <EditarQuestao v-model:questao="questao" />
        </div>


    </div>
</template>
